// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import Button from './ClientButton'
import { headlessButtonProps } from './Button'
export * from './types'
export { Button, headlessButtonProps }
